import { render, staticRenderFns } from "./SubDashboardAlert.vue?vue&type=template&id=cc2daa2a&scoped=true&"
import script from "./SubDashboardAlert.vue?vue&type=script&lang=ts&"
export * from "./SubDashboardAlert.vue?vue&type=script&lang=ts&"
import style0 from "./SubDashboardAlert.vue?vue&type=style&index=0&id=cc2daa2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2daa2a",
  null
  
)

export default component.exports